// Spray blots - náhodné kaňky po celém pozadí stránky
function addSprayBlots() {
  // Najdeme spray container
  const container = document.querySelector('.spray-container');
  if (!container) {
    console.warn('Spray container not found');
    return;
  }
  
  // Zkontrolujeme, jestli už má container kaňky
  if (container.querySelector('.spray-blot')) {
    return; // Už má kaňky, přeskočíme
  }
  
  // Náhodný počet kaňek (5-12)
  const numBlots = Math.floor(Math.random() * 8) + 5;
  
  // Seznam splash obrázků - získáme cesty z data atributů v body
  const splashPaths = document.body.dataset.splashPaths;
  if (!splashPaths) {
    console.warn('Splash paths not found in body dataset');
    return;
  }
  const splashes = JSON.parse(splashPaths);
  
    // Barvy s gradienty (modrá a růžová) - kratší přechody pro lepší viditelnost
    const colors = [
      { 
        name: 'blue', 
        gradient: 'radial-gradient(circle at 40% 40%, #60a5fa 0%, #3b82f6 30%, #1d4ed8 60%, #7c3aed 100%)' 
      },
      { 
        name: 'pink', 
        gradient: 'radial-gradient(circle at 40% 40%, #fda4af 0%, #f472b6 30%, #ec4899 60%, #be185d 100%)' 
      },
      { 
        name: 'purple', 
        gradient: 'radial-gradient(circle at 40% 40%, #c084fc 0%, #a855f7 30%, #7c3aed 60%, #4c1d95 100%)' 
      },
      { 
        name: 'yellow-pink', 
        gradient: 'radial-gradient(circle at 40% 40%, #fde047 0%, #fbbf24 20%, #f59e0b 40%, #ec4899 100%)' 
      }
    ];
  
  // Přidáme kaňky na body
  for (let i = 0; i < numBlots; i++) {
    const blot = document.createElement('div');
    const randomSplash = splashes[Math.floor(Math.random() * splashes.length)];
    const randomColor = colors[Math.floor(Math.random() * colors.length)];
    
    blot.className = `spray-blot spray-blot--${randomColor.name}`;
    
    // Základní nastavení pozice (přepíše se po načtení obrázku)
    blot.style.position = 'absolute';
    blot.style.zIndex = '-1';
    blot.style.pointerEvents = 'none';
    
    // Nastavíme splash jako masku s gradientem pozadí
    blot.style.background = randomColor.gradient;
    blot.style.maskImage = `url(${randomSplash})`;
    blot.style.webkitMaskImage = `url(${randomSplash})`;
    blot.style.maskSize = 'contain';
    blot.style.webkitMaskSize = 'contain';
    blot.style.maskRepeat = 'no-repeat';
    blot.style.webkitMaskRepeat = 'no-repeat';
    
    // Načteme velikost a nastavíme náhodnou velikost 25-50% originálu
    const img = new Image();
    img.onload = function() {
      const scale = 0.25 + (Math.random() * 0.25); // 0.25 až 0.5
      const width = this.width * scale;
      const height = this.height * scale;
      blot.style.width = `${width}px`;
      blot.style.height = `${height}px`;
      
      // Umístíme jen u okrajů - náhodně vybereme okraj
      const edge = ['top', 'right', 'bottom', 'left'][Math.floor(Math.random() * 4)];
      
      switch(edge) {
        case 'top':
          // Horní okraj: top -50% až 5%, left libovolně
          blot.style.top = `${(Math.random() * 55) - 50}%`;
          blot.style.left = `${(Math.random() * 150) - 50}%`;
          break;
        case 'bottom':
          // Dolní okraj: top 95% až 100%, left libovolně
          blot.style.top = `${95 + (Math.random() * 5)}%`;
          blot.style.left = `${(Math.random() * 150) - 50}%`;
          break;
        case 'left':
          // Levý okraj: left -50% až 5%, top libovolně
          blot.style.left = `${(Math.random() * 55) - 50}%`;
          blot.style.top = `${(Math.random() * 150) - 50}%`;
          break;
        case 'right':
          // Pravý okraj: left 95% až 100%, top libovolně
          blot.style.left = `${95 + (Math.random() * 5)}%`;
          blot.style.top = `${(Math.random() * 150) - 50}%`;
          break;
      }
    };
    img.src = randomSplash;
    
    container.appendChild(blot);
  }
}

document.addEventListener('DOMContentLoaded', addSprayBlots);
document.addEventListener('turbo:load', addSprayBlots);
